import { EditorName } from '../config/handlers/EditorEventsHandlers';

export const navigateToSection = (index: number, editorName: EditorName) => {
  const sectionsHeadings = document.querySelectorAll(
    `#${editorName} h1.section-heading`,
  );
  if (sectionsHeadings.length > 0 && index < sectionsHeadings.length) {
    sectionsHeadings[index].scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
};

export const getDocumentHeadings = (editorName: EditorName): Element[] => {
  const headings = document.querySelectorAll(
    `#${editorName} h1.section-heading, #${editorName} h1:not(.section-heading), #${editorName} h2, #${editorName} h3, #${editorName} h4`,
  );
  return Array.from(headings).filter(
    (heading) =>
      !heading.closest('.ck-pagination-view') &&
      !heading.classList.contains('fake'),
  );
};

export const navigateToHeading = (index: number, editorName: EditorName) => {
  const headings = getDocumentHeadings(editorName);
  if (headings.length > 0 && index < headings.length) {
    headings[index].scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
};
